import { render, staticRenderFns } from "./CheckboxesFieldtype.vue?vue&type=template&id=5bfeacc6&"
import script from "./CheckboxesFieldtype.vue?vue&type=script&lang=js&"
export * from "./CheckboxesFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports